import { useState } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  getMicSensitivityCorrection,
  getMicSensitivity
} from "src/modules/baby-station/duck/selectors";
import MicSensitivity from "src/modules/station/enums/MicSensitivity";
import { setMicSensitivityCorrection } from "src/modules/baby-station/duck/actions";
import Menu from "src/components/Menu";
import { Subtitle, BodyText2 } from "src/atoms/typography";
import Slider from "src/components/Slider";

export default function NoiseSensitivityCorrection({
  isOpen,
  onClose,
  anchor,
  noiseMeter
}) {
  const storedCorrection = useSelector(getMicSensitivityCorrection);
  const storedSensitivity = useSelector(getMicSensitivity);

  const [correction, setCorrection] = useState(
    storedCorrection ? storedCorrection * 50 + 50 : 50
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();

  function confirm() {
    const rangedCorrection = (correction - 50) / 50;
    dispatch(setMicSensitivityCorrection(rangedCorrection));
    noiseMeter.setSensitivity(
      MicSensitivity[storedSensitivity].value,
      rangedCorrection
    );
  }

  return (
    <Menu
      elevationLevel={2}
      placement="top-end"
      // transformOrigin={{
      //   vertical: "top",
      //   horizontal: "right"
      // }}
      // anchorOrigin={{
      //   vertical: 0,
      //   horizontal: 25
      // }}
      anchorEl={anchor}
      isOpen={isOpen}
      onClose={onClose}
    >
      <Flex
        py="12px"
        px="24px"
        width="228px"
        alignItems="center"
        justifyContent="center"
      >
        <Box width="100%">
          <Subtitle textAlign="center" mb="8px" color="highEmphasis">
            {t("buttons.adjustSensitivity")}
          </Subtitle>
          <Slider
            value={correction}
            onChange={(val) => setCorrection(val)}
            onChangeEnd={confirm}
          />
          <Flex justifyContent="space-between">
            <BodyText2 color="mediumEmphasis">
              {t("noiseSensitivity.level.low")}
            </BodyText2>
            <BodyText2 color="mediumEmphasis">0</BodyText2>
            <BodyText2 color="mediumEmphasis">
              {t("noiseSensitivity.level.high")}
            </BodyText2>
          </Flex>
        </Box>
      </Flex>
    </Menu>
  );
}
